import { useEffect, useRef, useState } from "react";
import { catalog, TmdbNotConfiguredError } from "../api/tmdb";
import PosterCard from "../components/PosterCard";
import { LoadingScreen, ErrorScreen, EmptyScreen } from "../components/StatusScreens";
import { getProgress } from "../storage/progress";

const LANGUAGES = [
  { code: null, label: "All" },
  { code: "ml", label: "Malayalam" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "hi", label: "Hindi" },
  { code: "kn", label: "Kannada" },
  { code: "bn", label: "Bengali" },
  { code: "mr", label: "Marathi" },
  { code: "pa", label: "Punjabi" },
  { code: "en", label: "English" },
];

export default function SearchScreen() {
  const [query, setQuery] = useState("");
  const [language, setLanguage] = useState(null);
  const [state, setState] = useState({ loading: true, results: [], error: null });
  const debounceRef = useRef(null);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setState((s) => ({ ...s, loading: true, error: null }));
      catalog
        .search(query, language)
        .then((results) => setState({ loading: false, results }))
        .catch((error) => {
          const message =
            error instanceof TmdbNotConfiguredError
              ? error.message
              : error.message || "Something went wrong. Try again.";
          setState({ loading: false, results: [], error: message });
        });
    }, 350);
    return () => clearTimeout(debounceRef.current);
  }, [query, language]);

  const hasFilter = query.trim().length > 0 || language != null;
  const getCardProgress = (card) =>
    card.contentType === "EPISODE" ? null : getProgress(card.contentType, card.tmdbId);

  return (
    <main className="page search-page">
      <div className="page-content">
        <h1 className="page-heading">Search</h1>
        <input
          className="search-input"
          type="search"
          placeholder="Search movies, shows, actors…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
          aria-label="Search movies and shows"
        />
        <div className="language-chips" role="group" aria-label="Filter by language">
          {LANGUAGES.map((l) => (
            <button
              key={l.code || "all"}
              className={`chip${language === l.code ? " active" : ""}`}
              onClick={() => setLanguage(l.code)}
            >
              {l.label}
            </button>
          ))}
        </div>

        {state.loading ? (
          <LoadingScreen label="Searching…" />
        ) : state.error ? (
          <ErrorScreen message={state.error} />
        ) : state.results.length === 0 ? (
          <EmptyScreen
            title={hasFilter ? "No results" : "Start exploring"}
            message={hasFilter ? "Try a different search term or language." : "Search for a title or pick a language to browse."}
          />
        ) : (
          <div className="results-grid">
            {state.results.map((card) => (
              <PosterCard key={card.contentType === "TV_SHOW" ? `tv-${card.tmdbId}` : `mv-${card.tmdbId}`} card={card} progress={getCardProgress(card)} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}